import { Component } from "@angular/core";

@Component({
	selector: "bp-content-load-indicator",
	templateUrl: "./bp-content-load-indicator.component.html",
	styleUrls: ["./bp-content-load-indicator.component.scss"],
	standalone: false
})
export class BpContentLoadIndicatorComponent {}
